import styled from "styled-components";

// Colores corporativos De Prado
const colors = {
  primary: "#203b34",
  primaryLight: "#f9ae17",
  secondary: "#f9ae17",
  terciary: "#E03A85",
  white: "#ffffff",
  gray: "#6b7280",
  grayLight: "#e5e7eb",
  grayBg: "#f9fafb",
  dark: "#1f2937",
};

export const ScoreCard = styled.div`
  background: ${colors.primary};
  padding: 24px 32px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(32, 59, 52, 0.3);
  text-align: center;
  width: 100%;
  border: 2px solid ${colors.primaryLight};

  @media (max-width: 768px) {
    padding: 20px 24px;
  }
`;

export const ScoreValue = styled.div`
  font-size: 48px;
  font-weight: 700;
  color: ${colors.primaryLight};
  margin-top: 8px;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const ScoreLabel = styled.div`
  font-size: 13px;
  color: ${colors.white};
  text-transform: uppercase;
  letter-spacing: 1.2px;
  font-weight: 600;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 8px 20px;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 600;
  margin-top: 8px;
  background: ${(props) => {
    switch (props.status) {
      case "completed":
      case "evaluated":
      case "notified":
      case "calibrated":
        return colors.primaryLight;
      case "pending":
      case "toEval":
        return colors.secondary;
      case "in_progress":
      case "toAuto":
      case "autoEval":
        return colors.terciary;
      default:
        return colors.gray;
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case "completed":
      case "evaluated":
      case "notified":
      case "calibrated":
        return colors.primary;
      default:
        return colors.white;
    }
  }};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoCard = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid ${colors.grayLight};
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const UserAvatar = styled.div`
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: 50%;
  background: ${colors.primary};
  border: 3px solid ${colors.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: ${colors.primaryLight};
  flex-shrink: 0;
`;

export const UserInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const UserTitle = styled.div`
  font-size: 18px;
  color: ${colors.dark};
  font-weight: 600;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const UserName = styled.div`
  font-size: 14px;
  color: ${colors.gray};
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const YearBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 4px;
  background: ${colors.dark};
  color: ${colors.white};
  font-size: 12px;
  font-weight: 600;
  margin-left: 4px;
`;

export const InfoLabel = styled.div`
  font-size: 12px;
  color: ${colors.gray};
  margin-bottom: 6px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
`;

export const InfoValue = styled.div`
  font-size: 17px;
  color: ${colors.dark};
  font-weight: 600;
`;

export const SectionTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.primary};
  margin: 40px 0 24px 0;
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 3px solid ${colors.primaryLight};

  i {
    color: ${colors.secondary};
    margin-right: 12px;
  }
`;

export const ObjectiveCard = styled.div`
  background: ${colors.white};
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid ${colors.grayLight};
  transition: all 0.2s ease;
  margin-bottom: 12px;
  width: auto;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-color: ${colors.primaryLight};
  }
`;

export const ObjectiveHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  user-select: none;
`;

export const ObjectiveNumber = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    ${colors.warning} 0%,
    ${colors.warning} 100%
  );
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
`;

export const ObjectiveWeight = styled.span`
  font-size: 12px;
  color: ${colors.gray};
  font-weight: 500;
  margin-left: 8px;
`;

export const SkillWeight = styled.span`
  font-size: 12px;
  color: ${colors.gray};
  font-weight: 500;
  margin-left: 0px;
`;

export const CompletionIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  margin-left: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  ${(props) =>
    props.$completed
      ? `
    background: rgba(13, 190, 190, 0.1);
    color: green;
    border: 1px solid green;
  `
      : `
    background: rgba(128, 128, 128, 0.1);
    color: ${colors.gray};
    border: 1px solid ${colors.grayLight};
  `}

  i {
    font-size: 10px;
  }
`;

export const InfoIcon = styled.i`
  font-size: 16px;
  color: #9ca3af;
  cursor: help;
  transition: color 0.2s ease;

  &:hover {
    color: #6b7280;
  }
`;

export const SkillName = styled.div`
  /* flex: 1; */
  font-size: 14px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SkillTitle = styled.div`
  font-size: 15px;
  color: ${colors.dark};
  font-weight: 400;
  line-height: 1.4;
  /* flex: 1; */
`;

export const ObjectiveTitle = styled.div`
  font-size: 15px;
  color: ${colors.dark};
  font-weight: 400;
  line-height: 1.4;
  flex: 1;
`;

export const ObjectiveDescription = styled.div`
  font-size: 14px;
  color: ${colors.gray};
  margin-top: 4px;
  line-height: 1.5;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 10px;
  background: ${colors.grayLight};
  border-radius: 5px;
  overflow: hidden;
  margin: 18px 0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(
    90deg,
    ${colors.primaryLight} 0%,
    ${colors.primary} 100%
  );
  border-radius: 5px;
  width: ${(props) => props.progress}%;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 10px rgba(13, 190, 190, 0.5);
`;

export const ScoreRow = styled.div`
  margin-top: 20px;
`;

export const ObjectiveExpandedContent = styled.div`
  flex: 0 0 calc(50% - 6px);
  display: flex;
  flex-direction: column;
  /* background: red; */
  background: ${colors.grayBg};

  border-radius: 8px;
  padding: 20px;
  /* margin-top: 16px; */
  border-left: 4px solid ${colors.primary};
  /* min-height: 100%; */
  @media (max-width: 768px) {
    flex: 1 1 auto;
  }
`;

export const ObjectiveAutoEvalButton = styled.button`
  background: ${colors.primary};
  color: ${colors.white};
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${colors.primaryLight};
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(13, 190, 190, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  i {
    font-size: 13px;
  }
`;

export const EvaluationFormContainer = styled.div`
  background: ${colors.grayBg};
  border-radius: 8px;
  padding: 24px;
  margin-top: 16px;
`;

export const FormTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.dark};
  margin-bottom: 20px;
`;

export const RatingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
`;

export const RatingOption = styled.button`
  background: ${(props) =>
    props.$selected
      ? props.$bgColor || colors.primary
      : `${props.$bgColor || colors.white}15`}; /* 15 = 8% opacity */
  color: ${(props) =>
    props.$selected
      ? props.$textColor || colors.white
      : props.$bgColor || colors.dark};
  border: 2px solid ${(props) => props.$borderColor || colors.grayLight};
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  font-weight: ${(props) => (props.$selected ? "700" : "600")};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;

  &:hover {
    background: ${(props) => props.$bgColor || colors.primary};
    color: ${(props) => props.$textColor || colors.white};
    border-color: ${(props) => props.$borderColor || colors.primary};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px
      ${(props) =>
        props.$bgColor
          ? `${props.$bgColor}40` /* 40 = 25% opacity */
          : "rgba(32, 59, 52, 0.15)"};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CommentSection = styled.div`
  margin-bottom: 20px;
`;

export const CommentLabel2 = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.dark};
  margin-bottom: 8px;
`;

export const CommentTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid ${colors.grayLight};
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${colors.primaryLight};
    box-shadow: 0 0 0 3px rgba(13, 190, 190, 0.1);
  }

  &::placeholder {
    color: ${colors.gray};
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-start;
`;

export const SaveButton = styled.button`
  background: ${colors.warning};
  color: ${colors.white};
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${colors.secondary};
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CancelButton = styled.button`
  background: transparent;
  color: ${colors.gray};
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${colors.grayLight};
    color: ${colors.dark};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const SelfAssessmentDisplay = styled.div`
  background: ${colors.grayBg};
  flex: 0 0 calc(50% - 6px);
  align-items: stretch;
`;

export const EvaluationResultCard = styled.div`
  flex: 0 0 calc(50% - 6px);
  background: ${({ $type }) =>
    $type === "auto"
      ? "linear-gradient(135deg, #eee 0%, #ddd 100%)"
      : "linear-gradient(135deg, #528f80 0%, #30584e 100%)"};
  border-radius: 8px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid ${({ $type }) => ($type === "auto" ? "#bbb" : "#60a5fa")};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    flex: 1 1 auto;
  }
`;

export const AssessmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const AssessmentTitle = styled.h5`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.dark};
  margin: 0;
`;

export const EditButton = styled.button`
  background: transparent;
  color: ${colors.warning};
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: rgba(249, 174, 23, 0.1);
  }
`;

export const AssessmentRating = styled.div`
  margin-bottom: 12px;
`;

export const RatingLabel = styled.span`
  font-size: 13px;
  color: ${colors.gray};
  font-weight: 500;
  margin-right: 8px;
`;

export const RatingBadge = styled.span`
  background: ${colors.primary};
  color: ${colors.white};
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 700;
  display: inline-block;
`;

export const AssessmentComment = styled.div`
  font-size: 14px;
  color: ${colors.dark};
  line-height: 1.6;
  font-style: italic;
`;

export const ScoreItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px;
  background: ${colors.grayBg};
  border-radius: 8px;
  border: 1px solid ${colors.grayLight};
`;

export const ScoreIcon = styled.i`
  font-size: 26px;
  color: ${(props) => (props.manager ? colors.secondary : colors.primaryLight)};
  width: 36px;
  text-align: center;
  flex-shrink: 0;
`;

export const ScoreText = styled.div`
  font-size: 12px;
  color: ${colors.gray};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ScoreBadge = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => (props.manager ? colors.secondary : colors.primary)};
  background: ${(props) =>
    props.manager ? "rgba(249, 174, 23, 0.15)" : "rgba(13, 190, 190, 0.15)"};
  padding: 6px 14px;
  border-radius: 6px;
  display: inline-block;
  margin-top: 4px;
  border: 1px solid
    ${(props) => (props.manager ? colors.secondary : colors.primaryLight)};
`;

export const CompetencyCard = styled(ObjectiveCard)`
  border-left-color: ${colors.terciary};

  &:hover {
    box-shadow: 0 4px 16px rgba(224, 58, 133, 0.2);
  }
`;

export const CompetencyHeader = styled.div`
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: space-between; */
  width: 100%;
  cursor: pointer;
  user-select: none;
`;

export const CompetencyBody = styled.div`
  margin-top: 16px;
`;

export const CommentBox = styled.div`
  background: ${colors.grayBg};
  border-left: 4px solid
    ${(props) => (props.isManager ? colors.secondary : colors.primaryLight)};
  padding: 14px 18px;
  margin-top: 14px;
  border-radius: 6px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CommentLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CommentText = styled.div`
  font-size: 14px;
  color: ${colors.dark};
  line-height: 1.6;
  font-style: italic;
`;

export const CollapseIcon = styled.i`
  color: ${colors.gray};
  transition: transform 0.3s ease;
  font-size: 16px;
  margin-left: 12px;

  &.expanded {
    transform: rotate(180deg);
  }

  &:hover {
    color: ${colors.primary};
  }
`;

export const ObjectiveSummary = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SkillSummary = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ObjectiveMainInfo = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const ObjectiveContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const ObjectiveScoreDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding-left: 16px;
`;

export const ObjectiveScoreValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.primary};
`;

export const ObjectiveScoreLabel = styled.div`
  font-size: 11px;
  color: ${colors.gray};
  font-weight: 500;
  text-transform: uppercase;
`;

export const SelfAssessedBadge = styled.div`
  background: ${colors.warning};
  color: ${colors.white};
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ActionButton = styled.button`
  background: ${colors.primary};
  color: ${colors.primaryLight};
  border: 2px solid ${colors.primaryLight};
  padding: 16px 40px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(32, 59, 52, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover:not(:disabled) {
    background: ${colors.primaryLight};
    color: ${colors.primary};
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(13, 190, 190, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${colors.gray};
    border-color: ${colors.gray};
    color: ${colors.grayLight};
    box-shadow: none;
  }

  i {
    margin-right: 10px;
  }
`;

export const SectionCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const SectionTitle2 = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EvaluationResultHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const EvaluationResultIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $type }) => ($type === "auto" ? "#f9ae17" : "#203b34")};
  color: #ffffff;
  font-size: 13px;
  flex-shrink: 0;
`;

export const EvaluationResultTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${({ $type }) => ($type === "auto" ? "#222" : "#ffff")};
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const EvaluationResultScore = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ $type }) => ($type === "auto" ? "#222" : "#fff")};
  margin-bottom: 2px;
`;

export const EvaluationResultLabel = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: ${({ $type }) => ($type === "auto" ? "#222" : "#fff")};
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
  margin-right: 10px;
`;

export const EvaluationComment = styled.div`
  margin-top: 8px;
  padding: 8px;
  background: ${({ $type }) =>
    $type === "auto" ? "rgba(61, 61, 61, 0.1)" : "rgba(32, 59, 52, 0.5)"};
  border-radius: 6px;
  border-left: 2px solid
    ${({ $type }) => ($type === "auto" ? "#203b34" : "rgb(249, 174, 23)")};
`;

export const EvaluationCommentLabel = styled.div`
  font-size: 9px;
  font-weight: 600;
  color: ${({ $type }) => ($type === "auto" ? "#203b34" : "#fff")};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 8px;
  }
`;

export const EvaluationFormContainerManager = styled.div`
  /* background: ${colors.grayBg};
  border-radius: 8px;
  padding: 24px;
  margin-top: 16px; */
  flex: 0 0 calc(50% - 6px);
  background: ${({ $type }) =>
    $type === "auto"
      ? "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)"
      : "linear-gradient(135deg, #528f80 0%, #30584e 100%)"};
  border-radius: 8px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid ${({ $type }) => ($type === "auto" ? "#fbbf24" : "#203b34")};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    flex: 1 1 auto;
  }
`;

export const EvaluationResultsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${colors.grayLight};
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FinalEvaluationCard = styled.div`
  /* background: linear-gradient(135deg, #ffec7d 0%, #764ba2 100%); */
  background: linear-gradient(135deg, #ffffffe0 0%, #cecece9b 100%);
  /* color: #f9ae17b0; */
  border-radius: 12px;
  padding: 20px 24px;
  /* margin-bottom: 24px; */
  /* color: #203b34; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 0.5px solid #203b34;
`;

export const FinalEvaluationLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  opacity: 0.95;
`;

export const FinalEvaluationValue = styled.div`
  font-size: 25px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #203b34;
`;
